var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "flex-column",
    attrs: {
      "id": "bio-project-materials"
    }
  }, [_c('div', {
    staticClass: "bio-project-selector"
  }, [_c('VHeader', {
    scopedSlots: _vm._u([{
      key: "project",
      fn: function () {
        return [_vm._v("\n        " + _vm._s(_vm.projectTitle) + "\n      ")];
      },
      proxy: true
    }])
  }), _vm._v(" "), !_vm.disableProjectSelector ? _c('multi-select-filter', {
    attrs: {
      "get-value": _vm.groupProjects,
      "id": "project-sel",
      "display-value": "title",
      "disable": _vm.disableProjectSelector,
      "current-set-value": _vm.selectedProject,
      "multiple": false,
      "update-method": _vm.updateProject,
      "filter-class": "bio-project-selector-filter",
      "label-class": "bio-project-selector-label",
      "track-by": "id"
    }
  }) : _vm._e(), _vm._v(" "), !_vm.disableProjectSelector && _vm.projectLength ? _c('VHeader', {
    staticClass: "bio-project-selector-project-number",
    scopedSlots: _vm._u([{
      key: "lower-subtitle",
      fn: function () {
        return [_vm._v("\n        " + _vm._s(_vm.projectSubtitle) + "\n      ")];
      },
      proxy: true
    }], null, false, 3011103435)
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "bio-project-materials-filter-wrapper"
    }
  }, [_c('b-form', [_c('fieldset', {
    staticClass: "bio-project-materials-filters"
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', {
    style: {
      height: _vm.rowHeight + 'em'
    }
  }, [_c('b-col', {
    class: _vm.isInBioTrackingStyle
  }, [_c('short-text-filter', {
    attrs: {
      "id": "flt-inp",
      "label": "Material Name",
      "get-value": _vm.nameFilter,
      "update-method": _vm.updateMaterialFilters,
      "path": "material-name",
      "placeholder": "Material Name"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    class: _vm.isInBioTrackingStyle
  }, [_c('multi-select-filter', {
    attrs: {
      "get-value": _vm.bioMaterialBundles,
      "id": "material-type-sel",
      "label": "Material Type",
      "path": "material-type",
      "current-set-value": _vm.selectedMatType,
      "multiple": true,
      "track-by": "id",
      "display-value": "label",
      "update-method": _vm.updateMaterialFilters
    }
  })], 1), _vm._v(" "), _c('b-col', {
    class: _vm.isInBioTrackingStyle
  }, [_c('multi-select-filter', {
    attrs: {
      "get-value": _vm.gmoOptions,
      "id": "material-type-sel",
      "label": "GMO?",
      "path": "gmo-sel",
      "current-set-value": _vm.selectedGMOOption,
      "multiple": true,
      "track-by": "id",
      "display-value": "label",
      "update-method": _vm.updateMaterialFilters
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    class: _vm.isInBioTrackingStyle
  }, [_c('multi-select-filter', {
    attrs: {
      "get-value": _vm.bioContainmentLevels,
      "id": "material-type-sel",
      "label": "Risk/Containment Level",
      "display-value": "label",
      "path": "containment-level",
      "current-set-value": _vm.selectedContainment,
      "update-method": _vm.updateMaterialFilters,
      "track-by": "id"
    }
  })], 1)], 1)], 1)], 1)])], 1), _vm._v(" "), _c('BaseTable', {
    ref: "table",
    attrs: {
      "items": _vm.filteredBioMaterials,
      "fields": _vm.fields,
      "total-items": _vm.filteredBioMaterials.length,
      "table-page-at": _vm.resultsPerPage,
      "items-per-page": _vm.resultsPerPage,
      "current-page": _vm.currentPage,
      "no-provider-paging": true,
      "custom-headers": ['select_all'],
      "no-local-sorting": false,
      "is-busy": _vm.isBusy,
      "class-prefix": "bio-pro-mat",
      "default-sort": "type_human_name"
    },
    on: {
      "sort-changed": _vm.sortingChangedEvent,
      "update-current-page": _vm.updateCurrentPage
    },
    scopedSlots: _vm._u([{
      key: "select-all",
      fn: function (row) {
        return [_c('b-form-checkbox', {
          attrs: {
            "name": "checkbox-1",
            "id": _vm.checkboxId(row)
          },
          on: {
            "change": function ($event) {
              _vm.unsavedChanges = true;
            }
          },
          model: {
            value: row.data.item.selected,
            callback: function ($$v) {
              _vm.$set(row.data.item, "selected", $$v);
            },
            expression: "row.data.item.selected"
          }
        })];
      }
    }, {
      key: "name_view",
      fn: function (row) {
        return [_vm._v("\n      " + _vm._s(row.data.item.name) + "\n      "), _c('BioMaterialDataWindow', {
          attrs: {
            "material-type": row.data.item.type,
            "material-type-label": row.data.item.type_human_name,
            "bio-uuid": row.data.item.material_uuid,
            "additional-id": row.data.item.material_id,
            "group-nid": _vm.groupNid
          }
        })];
      }
    }, {
      key: "select_all-header",
      fn: function (data) {
        return [_c('b-form-checkbox', {
          attrs: {
            "name": "select-all-bio-materials"
          },
          on: {
            "change": function ($event) {
              return _vm.selectedAllIgnoredToggle();
            }
          },
          model: {
            value: _vm.selectAll,
            callback: function ($$v) {
              _vm.selectAll = $$v;
            },
            expression: "selectAll"
          }
        }, [_vm._v("\n        Select All\n      ")])];
      }
    }, {
      key: "empty",
      fn: function () {
        return [_c('div', {
          staticClass: "biologicals-empty-text"
        }, [_vm._v("\n        There are currently no biological materials to list.\n      ")])];
      },
      proxy: true
    }])
  }), _vm._v(" "), !_vm.isInBioWizard ? _c('a', {
    attrs: {
      "href": "#",
      "id": "add-bio-materials-trigger"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.displaySearchAddModal.apply(null, arguments);
      }
    }
  }, [_vm._v("Add biological material to " + _vm._s(_vm.groupTitle))]) : _vm._e(), _vm._v(" "), _vm.isInBioWizard && _vm.bioMaterialBundles.length > 0 ? _c('SearchAddFromLibraryModal', {
    attrs: {
      "bio-material-bundles": _vm.bioMaterialBundles,
      "group-title": _vm.groupTitle,
      "group-nid": _vm.groupNid,
      "enable-bio-material-type-select": true
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bio-project-selector-actions-wrapper floating-save-bar"
  }, [_c('div', {
    staticClass: "bio-project-selector-action-buttons"
  }, [_c('div', {
    staticClass: "first-set-action"
  }, [_c('div', {
    staticClass: "first-set-action-item"
  }, [!_vm.unsavedChanges ? _c('div', [_vm._v("\n            Please press 'Save Changes' before navigating away from this page,\n            or selecting another Research Project to avoid losing unsaved\n            changes.\n          ")]) : _vm._e(), _vm._v(" "), _vm.unsavedChanges ? _c('VBanner', {
    attrs: {
      "color": "warning",
      "alt": "Unsaved changes detected",
      "id": "banner"
    }
  }, [_vm._v("Please press 'Save Changes' before navigating away from this\n            page, or selecting another Research Project to avoid losing\n            unsaved changes.")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "first-set-action-item"
  }, [_c('VButton', {
    staticClass: "primary",
    attrs: {
      "enable-prevent": true
    },
    on: {
      "click": _vm.saveChanges
    }
  }, [_vm._v("\n            Save Changes\n          ")])], 1)]), _vm._v(" "), _vm.displaySecondSet ? _c('div', {
    staticClass: "second-set-actions"
  }, [_c('VButton', {
    staticClass: "clear",
    attrs: {
      "id": "done"
    },
    on: {
      "click": _vm.emitCloseModal
    }
  }, [_vm._v("\n          Done\n        ")]), _vm._v(" "), _vm.specifyLink ? _c('VButton', {
    staticClass: "clear",
    attrs: {
      "id": "specify-usage"
    },
    on: {
      "click": _vm.navigateToSpecifyUsage
    }
  }, [_vm._v("\n          Specify Usage\n        ")]) : _vm._e()], 1) : _vm._e()])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }